// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sign-up-page {
  font-size: 16px;
  font-family: Inter;
  color: #101828;
  display: flex;
  min-height: 100vh;
  transition: opacity 0.3s linear;
}

  #sign-up-page #successful-signup-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 750px;
  }

  #sign-up-page #successful-signup-card h1 {
      text-align: center;
    }

  #sign-up-page #successful-signup-card h1 span {
        display: block;
        margin-top: 0.5rem;
        font-weight: 200;
        font-size: 1.25rem;
      }

  #sign-up-page #successful-signup-card h3 {
      text-align: center;
    }

  #sign-up-page #successful-signup-card h3 span {
        color: rgb(76, 39, 238);
        text-decoration: underline;
        cursor: pointer;
      }

  #sign-up-page #form-section {
    min-width: 45%;
    max-height: 100vh;
    overflow: auto;
    flex-direction: column;
    justify-content: center;
  }

  #sign-up-page #form-section .optional-text {
      color: #8890a5;
    }

  #sign-up-page #form-section #form-wrapper {
      width: 100%;
      padding: 3% 8%;
      margin: 0 auto;
    }

  #sign-up-page #form-section #form-heading {
      margin-bottom: 1.5em;
    }

  #sign-up-page #form-section #form-heading h3 {
        font-size: 2em;
        margin: 0;
        margin-bottom: 0.25em;
      }

  #sign-up-page #form-section #form-heading p {
        margin: 0;
        font-size: 0.9em;
        color: #475467;
      }

  #sign-up-page #form-section #have-account-prompt {
      width: 100%;
      text-align: center;
      color: #475467;
      font-size: 0.9em;
      margin-top: 0.5em;
    }

  #sign-up-page #form-section #have-account-prompt a {
        font-weight: 600;
        color: #6c239a;
      }

  #sign-up-page #hero-section {
    flex-grow: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  #sign-up-page #hero-section #hero-image-background {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

  #sign-up-page #hero-section #hero-image-background img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 50% 35%;
      }

  #sign-up-page #hero-section #hero-image-background #purple-velvet {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #2a0642;
        opacity: 0.85;
      }

  #sign-up-page #hero-section #hero-content {
      padding: 0 5%;
    }

  #sign-up-page #hero-section #hero-content #hero-chicory-logo {
        width: 400px;
        position: relative;
        left: -25px;
        margin-bottom: -0.5em;
      }

  #sign-up-page #hero-section #hero-content h2 {
        font-size: 4em;
        font-weight: 600;
        color: white;
        margin: 0.5em 0;
      }

  #sign-up-page #hero-section #hero-content p {
        font-size: 1.5em;
        color: #f6efff;
        width: 85%;
      }

  #sign-up-page #hero-section #creators {
      display: flex;
      align-items: center;
      margin-top: 3em;
    }

  #sign-up-page #hero-section #creators #creators-icons {
        display: flex;
        margin-right: calc(-0.5em * 3);
      }

  #sign-up-page #hero-section #creators #creators-icons img {
          width: 4em;
          border: 2px solid white;
          border-radius: 50%;
          position: relative
        }

  #sign-up-page #hero-section #creators #creators-icons img:nth-child(0) {
            left: calc(-0.5em * 0);
          }

  #sign-up-page #hero-section #creators #creators-icons img:nth-child(1) {
            left: calc(-0.5em * 1);
          }

  #sign-up-page #hero-section #creators #creators-icons img:nth-child(2) {
            left: calc(-0.5em * 2);
          }

  #sign-up-page #hero-section #creators #creators-icons img:nth-child(3) {
            left: calc(-0.5em * 3);
          }

  #sign-up-page #hero-section #creators #creators-icons img:nth-child(4) {
            left: calc(-0.5em * 4);
          }

  #sign-up-page #hero-section #creators #creators-icons img:nth-child(5) {
            left: calc(-0.5em * 5);
          }

  #sign-up-page #hero-section #creators > span {
        color: white;
        font-size: 1.25em;
      }

#sign-up-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#sign-up-form .general-validation-error {
    color: #ff0000;
    margin-bottom: 1rem;
  }

#sign-up-form .validation-error {
    display: flex;
    align-items: center;
    color: #ff0000;
    font-size: 0.8em;
  }

#sign-up-form #reference-reason-error-container {
    margin-top: 0.5rem;
  }

#sign-up-form #reference-reason-error-container .validation-error .invalid-flag {
      margin-right: 0.25rem;
      position: relative;
      top: -1px;
    }

#sign-up-form .invalid-flag svg path {
      stroke: #ff0000;
    }

#sign-up-form .optional-field-label {
    color: #667085;
  }

#sign-up-form .field-container {
    position: relative;
  }

#sign-up-form .field-container--spaced {
      margin-top: 1em;
    }

#sign-up-form .field-container .field-heading {
      height: 1.5em;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

#sign-up-form .field-container .field-heading label {
        color: #344054;
        font-size: 1em;
        font-weight: 400;
      }

#sign-up-form .field-container .field-heading label.invalid-flag {
        color: #ff0000;
      }

#sign-up-form .field-container .field-heading .validation-error {
        max-width: 60%;
      }

#sign-up-form .field-container .field-heading .validation-error .invalid-flag {
          margin-right: 0.25em;
        }

#sign-up-form .field-container .field-heading .validation-error .validation-error-text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

#sign-up-form .field-container input {
      border: 1px solid #a0a5aa;
      border-radius: 0.3em;
      padding: 0.5em 0.5em;
      margin-top: 0.25em;
      font-size: 1.1em;
      font-weight: 400;
      color: black
    }

#sign-up-form .field-container input:focus {
        border: 1px solid #6c239a;
      }

#sign-up-form .field-container input.invalid-flag {
        border: 2px solid #ff0000;
      }

#sign-up-form .field-container input::placeholder {
        font-weight: 200;
        font-size: 0.9em;
        color: #667085;
      }

#sign-up-form .field-container #source-dropdown {
      display: block;
      min-width: 100%;
      margin-top: 0.25em;
      border: 1px solid #a0a5aa;
      border-radius: 0.25em;
      padding: 0.5em 0.5em;
      font-size: 1.2em;
      outline-color: #6c239a;
      cursor: pointer;
    }

#sign-up-form .field-container #source-dropdown.focus-visible {
        outline-style: solid;
      }

#sign-up-form .field-container #source-dropdown:focus-visible {
        outline-style: solid;
      }

#sign-up-form .field-container #source-dropdown {
      -webkit-appearance: none;
              appearance: none;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
      background-repeat: no-repeat;
      background-position: right 0.5rem center;
      background-size: 1em;
      color: #101828;
    }

#sign-up-form .field-container span.field-note {
      display: block;
      color: #667085;
      font-size: 0.8em;
      margin-top: 0.5em;
    }

#sign-up-form #sign-up-form-top-fields {
    display: flex;
    justify-content: center;
    grid-gap: 1em;
    gap: 1em;
    margin-bottom: 0.75em;
  }

#sign-up-form #sign-up-form-top-fields .field-container {
      width: 50%;
    }

#sign-up-form #website-field-container {
    display: flex;
    margin-top: 0.5em;
    border-radius: 0.5em;
  }

#sign-up-form #website-field-container #static-protocol-badge {
      display: flex;
      align-items: center;
      padding: 0.5em 0.75em;
      background: #f9fafb;
      border: 1px solid #d0d5dd;
      border-right: none;
      border-top-left-radius: 0.5em;
      border-bottom-left-radius: 0.5em;
      font-size: 1.1em;
      font-weight: 300;
      color: #667085;
    }

#sign-up-form #website-field-container input {
      margin: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      padding-left: 0.5em;
    }

#sign-up-form #website-field-container.invalid-flag {
      border: 2px solid #ff0000;
    }

#sign-up-form #checks-container {
    margin-top: 1em;
    margin-bottom: 1em;
  }

#sign-up-form #checks-container .check-entry {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 1em 0;
    }

#sign-up-form #checks-container .check-entry input {
        cursor: pointer;
        min-width: 1.25em;
        min-height: 1.25em;
        max-width: 1.25em;
        max-height: 1.25em;
        margin: 0;
        accent-color: #6c239a
      }

#sign-up-form #checks-container .check-entry input:focus {
          outline: 1px solid purple;
        }

#sign-up-form #checks-container .check-entry label {
        color: #344054;
        font-size: 0.9em;
        padding-left: 0.75em;
      }

#sign-up-form #checks-container .check-entry label a {
          color: #6c239a;
          text-decoration: underline;
        }

#sign-up-form #checks-container #terms-error {
      height: 1em;
      display: flex;
      align-items: center;
      margin-bottom: 0.5em;
      font-size: 0.85em;
    }

#sign-up-form #checks-container #terms-error .invalid-flag {
        margin-right: 0.5em;
      }

#sign-up-form #checks-container #terms-error .validation-error {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

#sign-up-form button[type='submit'] {
    margin: 0.25em 0;
    width: 100%;
    padding: 1em;
    font-weight: 600;
    border-radius: 8px;
    border: 1px solid #d0d5dd;
    transition: all 0.3s ease-in-out;
    font-size: 1.2em;
    color: white;
    background: #6c239a;
    cursor: pointer;
    transform: scale(100%)
  }

#sign-up-form button[type='submit']:hover {
      background: #922ed1;
    }

#sign-up-form button[type='submit']:disabled {
      cursor: not-allowed;
      opacity: 0.8;
      background: #8890a5;
      transform: scale(80%)
    }

#sign-up-form button[type='submit']:disabled:hover {
        background: #8890a5;
      }

@media screen and (max-width: 900px) {
  #sign-up-page {
    flex-direction: column-reverse;
  }
    #sign-up-page #hero-section {
      font-size: 12px;
      padding: 2em 0;
    }
      #sign-up-page #hero-section #hero-chicory-logo {
        margin: 0 auto;
        left: -15px !important;
        width: 300px !important;
      }
      #sign-up-page #hero-section #hero-content h2 {
        font-weight: 400;
        font-size: 2.5em;
      }
      #sign-up-page #hero-section #hero-content p {
        width: 100%;
        font-size: 1.5em;
      }
      #sign-up-page #hero-section #creators {
        margin-top: 0
      }
        #sign-up-page #hero-section #creators > span {
          font-size: 1.25em;
        }
    #sign-up-page #form-wrapper {
      padding: 3% 4% !important;
    }
    #sign-up-page #form-section {
      margin-top: 1rem;
      max-height: auto;
      overflow: visible;
    }
}

@media screen and (max-width: 1200px) {
    #sign-up-page #sign-up-form-top-fields {
      display: block;
    }
      #sign-up-page #sign-up-form-top-fields .field-container {
        width: 100%;
        margin-bottom: 0.5em;
      }
      #sign-up-page #hero-section #hero-chicory-logo {
        margin: 0 auto;
        left: -15px !important;
        width: 350px !important;
      }
      #sign-up-page #hero-section #hero-content h2 {
        font-weight: 400;
        font-size: 3em;
      }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SignupPage/main.pcss"],"names":[],"mappings":"AAcA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AA8JjC;;EA5JE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;EAkBf;;EAjBE;MACE,kBAAkB;IAOpB;;EANE;QACE,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;MACpB;;EAEF;MACE,kBAAkB;IAMpB;;EALE;QACE,uBAAuB;QACvB,0BAA0B;QAC1B,eAAe;MACjB;;EAIJ;IACE,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;EAiCzB;;EAhCE;MACE,cAAoB;IACtB;;EACA;MACE,WAAW;MACX,cAAc;MACd,cAAc;IAChB;;EACA;MACE,oBAAoB;IAWtB;;EAVE;QACE,cAAc;QACd,SAAS;QACT,qBAAqB;MACvB;;EACA;QACE,SAAS;QACT,gBAAgB;QAChB,cAAgB;MAClB;;EAEF;MACE,WAAW;MACX,kBAAkB;MAClB,cAAgB;MAChB,gBAAgB;MAChB,iBAAiB;IAKnB;;EAJE;QACE,gBAAgB;QAChB,cAAqB;MACvB;;EAIJ;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EAqFzB;;EApFE;MACE,kBAAkB;MAClB,WAAW;MACX,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY;IAmBd;;EAlBE;QACE,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,wBAAwB;MAC1B;;EACA;QACE,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,aAAa;MACf;;EAEF;MACE,aAAa;IAkBf;;EAjBE;QACE,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,qBAAqB;MACvB;;EACA;QACE,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,eAAe;MACjB;;EACA;QACE,gBAAgB;QAChB,cAAgB;QAChB,UAAU;MACZ;;EAEF;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;IAkCjB;;EAjCE;QAEE,aAAa;QACb,8BAAmC;MAyBrC;;EAxBE;UACE,UAAU;UACV,uBAAuB;UACvB,kBAAkB;UAClB;QAmBF;;EAlBE;YACE,sBAA2B;UAC7B;;EACA;YACE,sBAA2B;UAC7B;;EACA;YACE,sBAA2B;UAC7B;;EACA;YACE,sBAA2B;UAC7B;;EACA;YACE,sBAA2B;UAC7B;;EACA;YACE,sBAA2B;UAC7B;;EAGJ;QACE,YAAY;QACZ,iBAAiB;MACnB;;AAKN;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AA0NhC;;AAzNE;IACE,cAAW;IACX,mBAAmB;EACrB;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAW;IACX,gBAAgB;EAClB;;AACA;IACE,kBAAkB;EAMpB;;AALE;MACE,qBAAqB;MACrB,kBAAkB;MAClB,SAAS;IACX;;AAGA;MACE,eAAY;IACd;;AAEF;IACE,cAAqB;EACvB;;AAEA;IACE,kBAAkB;EA4EpB;;AA3EE;MACE,eAAe;IACjB;;AACA;MACE,aAAa;MACb,aAAa;MACb,mBAAmB;MACnB,8BAA8B;IAoBhC;;AAnBE;QACE,cAAiB;QACjB,cAAc;QACd,gBAAgB;MAClB;;AACA;QACE,cAAW;MACb;;AACA;QACE,cAAc;MAShB;;AARE;UACE,oBAAoB;QACtB;;AACA;UACE,gBAAgB;UAChB,mBAAmB;UACnB,uBAAuB;QACzB;;AAIJ;MACE,yBAAoC;MACpC,oBAAoB;MACpB,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB;IAYF;;AAXE;QACE,yBAAgC;MAClC;;AACA;QACE,yBAAsB;MACxB;;AACA;QACE,gBAAgB;QAChB,gBAAgB;QAChB,cAAqB;MACvB;;AAEF;MACE,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,yBAAoC;MACpC,qBAAqB;MACrB,oBAAoB;MACpB,gBAAgB;MAChB,sBAA6B;MAC7B,eAAe;IAUjB;;AATE;QACE,oBAAoB;MACtB;;AAFA;QACE,oBAAoB;MACtB;;AAZF;MAaE,wBAAgB;cAAhB,gBAAgB;MAChB,yDAA2R;MAC3R,4BAA4B;MAC5B,wCAAwC;MACxC,oBAAoB;MACpB,cAAiB;IACnB;;AACA;MACE,cAAc;MACd,cAAqB;MACrB,gBAAgB;MAChB,iBAAiB;IACnB;;AAEF;IACE,aAAa;IACb,uBAAuB;IACvB,aAAQ;IAAR,QAAQ;IACR,qBAAqB;EAIvB;;AAHE;MACE,UAAU;IACZ;;AAEF;IACE,aAAa;IACb,iBAAiB;IACjB,oBAAoB;EAuBtB;;AAtBE;MACE,aAAa;MACb,mBAAmB;MACnB,qBAAqB;MACrB,mBAAsB;MACtB,yBAA8B;MAC9B,kBAAkB;MAClB,6BAA6B;MAC7B,gCAAgC;MAChC,gBAAgB;MAChB,gBAAgB;MAChB,cAAqB;IACvB;;AACA;MACE,SAAS;MACT,yBAAyB;MACzB,4BAA4B;MAC5B,mBAAmB;IACrB;;AACA;MACE,yBAAsB;IACxB;;AAEF;IACE,eAAe;IACf,kBAAkB;EA4CpB;;AA3CE;MACE,aAAa;MACb,2BAA2B;MAC3B,mBAAmB;MACnB,aAAa;IAuBf;;AAtBE;QAEE,eAAe;QACf,iBAAwB;QACxB,kBAAyB;QACzB,iBAAwB;QACxB,kBAAyB;QACzB,SAAS;QACT;MAIF;;AAHE;UACE,yBAAyB;QAC3B;;AAEF;QACE,cAAiB;QACjB,gBAAgB;QAChB,oBAAoB;MAKtB;;AAJE;UACE,cAAqB;UACrB,0BAA0B;QAC5B;;AAGJ;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,oBAAoB;MACpB,iBAAiB;IASnB;;AARE;QACE,mBAAmB;MACrB;;AACA;QACE,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;MACzB;;AAGJ;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAA8B;IAC9B,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;IACZ,mBAA0B;IAC1B,eAAe;IACf;EAeF;;AAbE;MACE,mBAAkC;IACpC;;AAEA;MACE,mBAAmB;MACnB,YAAY;MACZ,mBAAyB;MACzB;IAIF;;AAHE;QACE,mBAAyB;MAC3B;;AAKN;EACE;IACE,8BAA8B;EAgChC;IA/BE;MACE,eAAe;MACf,cAAc;IAoBhB;MAnBE;QACE,cAAc;QACd,sBAAsB;QACtB,uBAAuB;MACzB;MACA;QACE,gBAAgB;QAChB,gBAAgB;MAClB;MACA;QACE,WAAW;QACX,gBAAgB;MAClB;MACA;QACE;MAIF;QAHE;UACE,iBAAiB;QACnB;IAGJ;MACE,yBAAyB;IAC3B;IACA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,iBAAiB;IACnB;AAEJ;;AAEA;IAEI;MACE,cAAc;IAKhB;MAJE;QACE,WAAW;QACX,oBAAoB;MACtB;MAGA;QACE,cAAc;QACd,sBAAsB;QACtB,uBAAuB;MACzB;MACA;QACE,gBAAgB;QAChB,cAAc;MAChB;AAGN","sourcesContent":["$chicoryPurple: #6c239a;\n$brighterChicoryPurple: #922ed1;\n$textBlack: #101828;\n$white: #fff;\n$offWhite: #f6efff;\n$darkSlate: #344054;\n$textGray: #475467;\n$textLightGray: #667085;\n$borderColor: #d0d5dd;\n$darkerBorderColor: #a0a5aa;\n$badgeGray: #f9fafb;\n$textOptional: #8890a5;\n$red: #ff0000;\n\n#sign-up-page {\n  font-size: 16px;\n  font-family: Inter;\n  color: $textBlack;\n  display: flex;\n  min-height: 100vh;\n  transition: opacity 0.3s linear;\n\n  #successful-signup-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    height: 750px;\n    h1 {\n      text-align: center;\n      span {\n        display: block;\n        margin-top: 0.5rem;\n        font-weight: 200;\n        font-size: 1.25rem;\n      }\n    }\n    h3 {\n      text-align: center;\n      span {\n        color: rgb(76, 39, 238);\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n  }\n\n  #form-section {\n    min-width: 45%;\n    max-height: 100vh;\n    overflow: auto;\n    flex-direction: column;\n    justify-content: center;\n    .optional-text {\n      color: $textOptional;\n    }\n    #form-wrapper {\n      width: 100%;\n      padding: 3% 8%;\n      margin: 0 auto;\n    }\n    #form-heading {\n      margin-bottom: 1.5em;\n      h3 {\n        font-size: 2em;\n        margin: 0;\n        margin-bottom: 0.25em;\n      }\n      p {\n        margin: 0;\n        font-size: 0.9em;\n        color: $textGray;\n      }\n    }\n    #have-account-prompt {\n      width: 100%;\n      text-align: center;\n      color: $textGray;\n      font-size: 0.9em;\n      margin-top: 0.5em;\n      a {\n        font-weight: 600;\n        color: $chicoryPurple;\n      }\n    }\n  }\n\n  #hero-section {\n    flex-grow: 1;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    #hero-image-background {\n      position: absolute;\n      z-index: -1;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        object-position: 50% 35%;\n      }\n      #purple-velvet {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: #2a0642;\n        opacity: 0.85;\n      }\n    }\n    #hero-content {\n      padding: 0 5%;\n      #hero-chicory-logo {\n        width: 400px;\n        position: relative;\n        left: -25px;\n        margin-bottom: -0.5em;\n      }\n      h2 {\n        font-size: 4em;\n        font-weight: 600;\n        color: white;\n        margin: 0.5em 0;\n      }\n      p {\n        font-size: 1.5em;\n        color: $offWhite;\n        width: 85%;\n      }\n    }\n    #creators {\n      display: flex;\n      align-items: center;\n      margin-top: 3em;\n      #creators-icons {\n        $iconOffset: -0.5em;\n        display: flex;\n        margin-right: calc($iconOffset * 3);\n        img {\n          width: 4em;\n          border: 2px solid white;\n          border-radius: 50%;\n          position: relative;\n          &:nth-child(0) {\n            left: calc($iconOffset * 0);\n          }\n          &:nth-child(1) {\n            left: calc($iconOffset * 1);\n          }\n          &:nth-child(2) {\n            left: calc($iconOffset * 2);\n          }\n          &:nth-child(3) {\n            left: calc($iconOffset * 3);\n          }\n          &:nth-child(4) {\n            left: calc($iconOffset * 4);\n          }\n          &:nth-child(5) {\n            left: calc($iconOffset * 5);\n          }\n        }\n      }\n      & > span {\n        color: white;\n        font-size: 1.25em;\n      }\n    }\n  }\n}\n\n#sign-up-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .general-validation-error {\n    color: $red;\n    margin-bottom: 1rem;\n  }\n\n  .validation-error {\n    display: flex;\n    align-items: center;\n    color: $red;\n    font-size: 0.8em;\n  }\n  #reference-reason-error-container {\n    margin-top: 0.5rem;\n    .validation-error .invalid-flag {\n      margin-right: 0.25rem;\n      position: relative;\n      top: -1px;\n    }\n  }\n  .invalid-flag {\n    svg path {\n      stroke: $red;\n    }\n  }\n  .optional-field-label {\n    color: $textLightGray;\n  }\n\n  .field-container {\n    position: relative;\n    &--spaced {\n      margin-top: 1em;\n    }\n    .field-heading {\n      height: 1.5em;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      label {\n        color: $darkSlate;\n        font-size: 1em;\n        font-weight: 400;\n      }\n      label.invalid-flag {\n        color: $red;\n      }\n      .validation-error {\n        max-width: 60%;\n        .invalid-flag {\n          margin-right: 0.25em;\n        }\n        .validation-error-text {\n          overflow: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n\n    input {\n      border: 1px solid $darkerBorderColor;\n      border-radius: 0.3em;\n      padding: 0.5em 0.5em;\n      margin-top: 0.25em;\n      font-size: 1.1em;\n      font-weight: 400;\n      color: black;\n      &:focus {\n        border: 1px solid $chicoryPurple;\n      }\n      &.invalid-flag {\n        border: 2px solid $red;\n      }\n      &::placeholder {\n        font-weight: 200;\n        font-size: 0.9em;\n        color: $textLightGray;\n      }\n    }\n    #source-dropdown {\n      display: block;\n      min-width: 100%;\n      margin-top: 0.25em;\n      border: 1px solid $darkerBorderColor;\n      border-radius: 0.25em;\n      padding: 0.5em 0.5em;\n      font-size: 1.2em;\n      outline-color: $chicoryPurple;\n      cursor: pointer;\n      &:focus-visible {\n        outline-style: solid;\n      }\n      appearance: none;\n      background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n      background-repeat: no-repeat;\n      background-position: right 0.5rem center;\n      background-size: 1em;\n      color: $textBlack;\n    }\n    span.field-note {\n      display: block;\n      color: $textLightGray;\n      font-size: 0.8em;\n      margin-top: 0.5em;\n    }\n  }\n  #sign-up-form-top-fields {\n    display: flex;\n    justify-content: center;\n    gap: 1em;\n    margin-bottom: 0.75em;\n    .field-container {\n      width: 50%;\n    }\n  }\n  #website-field-container {\n    display: flex;\n    margin-top: 0.5em;\n    border-radius: 0.5em;\n    #static-protocol-badge {\n      display: flex;\n      align-items: center;\n      padding: 0.5em 0.75em;\n      background: $badgeGray;\n      border: 1px solid $borderColor;\n      border-right: none;\n      border-top-left-radius: 0.5em;\n      border-bottom-left-radius: 0.5em;\n      font-size: 1.1em;\n      font-weight: 300;\n      color: $textLightGray;\n    }\n    input {\n      margin: 0;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      padding-left: 0.5em;\n    }\n    &.invalid-flag {\n      border: 2px solid $red;\n    }\n  }\n  #checks-container {\n    margin-top: 1em;\n    margin-bottom: 1em;\n    .check-entry {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      margin: 1em 0;\n      input {\n        $checkBoxSize: 1.25em;\n        cursor: pointer;\n        min-width: $checkBoxSize;\n        min-height: $checkBoxSize;\n        max-width: $checkBoxSize;\n        max-height: $checkBoxSize;\n        margin: 0;\n        accent-color: $chicoryPurple;\n        &:focus {\n          outline: 1px solid purple;\n        }\n      }\n      label {\n        color: $darkSlate;\n        font-size: 0.9em;\n        padding-left: 0.75em;\n        a {\n          color: $chicoryPurple;\n          text-decoration: underline;\n        }\n      }\n    }\n    #terms-error {\n      height: 1em;\n      display: flex;\n      align-items: center;\n      margin-bottom: 0.5em;\n      font-size: 0.85em;\n      .invalid-flag {\n        margin-right: 0.5em;\n      }\n      .validation-error {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n  button[type='submit'] {\n    margin: 0.25em 0;\n    width: 100%;\n    padding: 1em;\n    font-weight: 600;\n    border-radius: 8px;\n    border: 1px solid $borderColor;\n    transition: all 0.3s ease-in-out;\n    font-size: 1.2em;\n    color: white;\n    background: $chicoryPurple;\n    cursor: pointer;\n    transform: scale(100%);\n\n    &:hover {\n      background: $brighterChicoryPurple;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.8;\n      background: $textOptional;\n      transform: scale(80%);\n      &:hover {\n        background: $textOptional;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 900px) {\n  #sign-up-page {\n    flex-direction: column-reverse;\n    #hero-section {\n      font-size: 12px;\n      padding: 2em 0;\n      #hero-chicory-logo {\n        margin: 0 auto;\n        left: -15px !important;\n        width: 300px !important;\n      }\n      #hero-content h2 {\n        font-weight: 400;\n        font-size: 2.5em;\n      }\n      #hero-content p {\n        width: 100%;\n        font-size: 1.5em;\n      }\n      #creators {\n        margin-top: 0;\n        & > span {\n          font-size: 1.25em;\n        }\n      }\n    }\n    #form-wrapper {\n      padding: 3% 4% !important;\n    }\n    #form-section {\n      margin-top: 1rem;\n      max-height: auto;\n      overflow: visible;\n    }\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  #sign-up-page {\n    #sign-up-form-top-fields {\n      display: block;\n      .field-container {\n        width: 100%;\n        margin-bottom: 0.5em;\n      }\n    }\n    #hero-section {\n      #hero-chicory-logo {\n        margin: 0 auto;\n        left: -15px !important;\n        width: 350px !important;\n      }\n      #hero-content h2 {\n        font-weight: 400;\n        font-size: 3em;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
